import React, { Component } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import { Helmet } from 'react-helmet';
import api from '../../services/api';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phone_number: '',
      company_name: '',
      service_type: '',
      address: '',
      city: '',
      state: '',
      country: '',
      postal_code: '',
      description: '',
      additional_notes: '',
      subject: '',
      status: 'pending', // default status
      loading: false,
      successMsg: '',
      errorMsg: ''
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSelectChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true, successMsg: '', errorMsg: '' });

    try {
      const payload = {
        name: this.state.name,
        email: this.state.email,
        phone_number: this.state.phone_number,
        company_name: this.state.company_name,
        service_type: this.state.service_type || 'general',
        address: this.state.address,
        city: this.state.city,
        state: this.state.state,
        country: this.state.country,
        postal_code: this.state.postal_code,
        description: this.state.description || this.state.message,
        additional_notes: this.state.additional_notes,
        subject: this.state.subject,
        status: this.state.status,
        date_of_inquiry: new Date().toISOString()
      };

      await api.post('/enquiries-submit', payload);

      this.setState({
        successMsg: 'Thank you for your message! We will contact you soon.',
        name: '',
        email: '',
        phone_number: '',
        company_name: '',
        service_type: '',
        address: '',
        city: '',
        state: '',
        country: '',
        postal_code: '',
        description: '',
        additional_notes: '',
        subject: '',
        loading: false
      });
    } catch (err) {
      this.setState({
        errorMsg: 'Failed to submit your message. Please try again later.',
        loading: false
      });
    }
  };

  render() {
    const serviceTypes = [
      { value: 'general', label: 'General Inquiry' },
      { value: 'partner', label: 'Partner Inquiry' },
      { value: 'service', label: '3rd Party Services Inquiry' },
      { value: 'skilled', label: 'Skilled Business Employee Inquiry' },

      { value: 'business', label: 'Business for sale Inquiry' }
    ];

    return (
      <div className="contact-page">
        <Helmet>
          <title>Contact Us - startupbusinesspartners</title>
        </Helmet>

        {/* Navbar */}
        <Navbar />

        <section className="breadcrumb_area breadcrumb2 bgimage biz_overlay">
          <div className="bg_image_holder" style={{ backgroundImage: 'url(https://snmtechnologies.in/startup/img/breadbg.jpg)', opacity: 1 }}>
            <img src="https://snmtechnologies.in/startup/img/breadbg.jpg" alt="" />
          </div>
          <div className="container content_above">
            <div className="row">
              <div className="col-md-12">
                <div className="breadcrumb_wrapper d-flex flex-column align-items-center">
                  <h4 className="page_title">Contact us</h4>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb m-bottom-30">
                      <li className="breadcrumb-item"><a href="#">Home</a></li>
                      <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Info Section */}
        <section className="contact-info py-5">
          <div className="container">
            <div className="row">
              <div className="col-md-4 mb-4 mb-md-0">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body text-center">
                    <div className="icon-box mb-3">
                      <i className="la la-map-marker la-3x text-primary"></i>
                    </div>
                    <h5>Our Location</h5>
                    <p className="mb-0">123 Business Avenue<br />Delhi, NCR, New Delhi, Delhi 110012</p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-4 mb-md-0">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body text-center">
                    <div className="icon-box mb-3">
                      <i className="la la-phone la-3x text-primary"></i>
                    </div>
                    <h5>Call Us</h5>
                    <p className="mb-0">
                      <a href="tel:+18005551234" className="text-dark">+91 88600 03484</a><br />
                      Mon-Fri: 9am-6pm
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body text-center">
                    <div className="icon-box mb-3">
                      <i className="la la-envelope la-3x text-primary"></i>
                    </div>
                    <h5>Email Us</h5>
                    <p className="mb-0">
                      <a href="mailto:info@yourcompany.com" className="text-dark">info@yourcompany.com</a><br />
                      Response within 24 hours
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form Section */}
        <section className="contact-form py-5 bg-light">
          <div className="container">
            {this.state.successMsg && (
              <div className="alert alert-success mb-4">
                {this.state.successMsg}
              </div>
            )}

            {this.state.errorMsg && (
              <div className="alert alert-danger mb-4">
                {this.state.errorMsg}
              </div>
            )}

            <div className="row">
              <div className="col-lg-6 mb-5 mb-lg-0">
                <h2 className="mb-4">Send Us a Message</h2>
                <form onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="name">Full Name *</label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={this.state.name}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Email Address *</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          value={this.state.email}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="phone_number">Phone Number *</label>
                        <input
                          type="tel"
                          className="form-control"
                          id="phone_number"
                          name="phone_number"
                          value={this.state.phone_number}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="company_name">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="company_name"
                          name="company_name"
                          value={this.state.company_name}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="service_type">Service Type *</label>
                        <select
                          className="form-control"
                          id="service_type"
                          name="service_type"
                          value={this.state.service_type}
                          onChange={(e) => this.handleSelectChange('service_type', e.target.value)}
                          required
                        >
                          <option value="">Select a service type</option>
                          {serviceTypes.map((service) => (
                            <option key={service.value} value={service.value}>
                              {service.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="subject">Subject *</label>
                        <select
                          className="form-control"
                          id="subject"
                          name="subject"
                          value={this.state.subject}
                          onChange={this.handleChange}
                          required
                        >
                          <option value="">Select a subject</option>
                          <option value="general">General Inquiry</option>
                          <option value="support">Technical Support</option>
                          <option value="sales">Sales Questions</option>
                          <option value="feedback">Feedback</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="address">Address</label>
                    <input
                      className="form-control"
                      id="address"
                      type="text"
                      name="address"
                      rows="2"
                      value={this.state.address}
                      onChange={this.handleChange}
                    ></input>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="city">City</label>
                        <input
                          type="text"
                          className="form-control"
                          id="city"
                          name="city"
                          value={this.state.city}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="state">State</label>
                        <input
                          type="text"
                          className="form-control"
                          id="state"
                          name="state"
                          value={this.state.state}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="country">Country</label>
                        <input
                          type="text"
                          className="form-control"
                          id="country"
                          name="country"
                          value={this.state.country}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="postal_code">Postal Code</label>
                    <input
                      type="text"
                      className="form-control"
                      id="postal_code"
                      name="postal_code"
                      value={this.state.postal_code}
                      onChange={this.handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="description">Message *</label>
                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      rows="5"
                      style={{ minHeight: '120px' }} // Approx height for 5 rows
                      value={this.state.description}
                      onChange={this.handleChange}
                      required
                    ></textarea>

                  </div>

                  <div className="form-group">
                    <label htmlFor="additional_notes">Additional Notes</label>
                    <textarea
                      className="form-control"
                      id="additional_notes"
                      name="additional_notes"
                      rows="5"
                      style={{ minHeight: '120px' }}
                      value={this.state.additional_notes}
                      onChange={this.handleChange}
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              </div>

              <div className="col-lg-6">
                <h2 className="mb-6">Find Us on Map</h2>
                <div className="map-container embed-responsive embed-responsive-16by9">
                  <iframe
                    title="Company Location"
                    className="embed-responsive-item"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1797893.5498248455!2d75.65597154297386!3d28.34340148125126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce19466e19ae1%3A0x45ceeb565fd5de6c!2sNational%20Capital%20Region!5e0!3m2!1sen!2sin!4v1753014464040!5m2!1sen!2sin"
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                </div>

                <div className="mt-6">
                  <h5>Business Hours</h5>
                  <ul className="list-unstyled">
                    <li>Monday - Friday: 9:00 AM - 6:00 PM</li>
                    <li>Saturday: 10:00 AM - 4:00 PM</li>
                    <li>Sunday: Closed</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>



        {/* Footer */}
        <Footer />
      </div>
    );
  }
}

export default Contact;